import React from "react";

export const IconOvernight = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m2.25 19.5v-5.25c0.00235-0.7949 0.31917-1.5566 0.88128-2.1187 0.5621-0.5621 1.3238-0.879 2.1187-0.8813h13.5c0.7949 0.0023 1.5566 0.3192 2.1187 0.8813s0.879 1.3238 0.8813 2.1187v5.25m-3.75-8.25h-13.5v-4.875c0.00148-0.49682 0.1995-0.97288 0.55081-1.3242s0.82737-0.54933 1.3242-0.55081h11.25c0.4968 0.00148 0.9729 0.1995 1.3242 0.55081s0.5493 0.82737 0.5508 1.3242v4.875h-1.5z"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m12 11.25v-0.75c0.0011-0.3975 0.1595-0.77837 0.4406-1.0594 0.281-0.28106 0.6619-0.43946 1.0594-0.44057h3.75c0.3975 0.00111 0.7784 0.15951 1.0594 0.44057 0.2811 0.28106 0.4395 0.66193 0.4406 1.0594v0.75m-16.5 8.25v-0.375c8.7e-4 -0.2981 0.11967-0.5837 0.33046-0.7945s0.49644-0.3296 0.79454-0.3305h17.25c0.2981 9e-4 0.5837 0.1197 0.7945 0.3305s0.3296 0.4964 0.3305 0.7945v0.375h-19.5zm3-8.25v-0.75c0.00111-0.3975 0.15951-0.77837 0.44057-1.0594s0.66195-0.43946 1.0594-0.44057h3.75c0.3975 0.00111 0.7784 0.15951 1.0594 0.44057 0.2811 0.28106 0.4395 0.66193 0.4406 1.0594v0.75h-6.75z"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconOvernight;
